import React from 'react';
import Linkify from 'react-linkify';
import renderHTML from 'react-render-html';

import PropTypes from 'prop-types';

export const DetailField = props => {
  const label = props.label;
  const content = props.content;
  const extra = props.extra;

  const className = props.className ? props.className : '';

  if (typeof content !== 'undefined' && content !== null && content !== false) {
    let contentAsNode = null;

    if (React.isValidElement(content)) {
      contentAsNode = content;
    } else if (
      content.length ||
      (content.value !== null &&
        typeof content.value !== 'undefined' &&
        content.value.length)
    ) {
      const actualContent =
        typeof content === 'string' ? content : content.value;
      const note =
        typeof extra !== 'undefined' && extra !== null && extra.length
          ? extra
          : null;
      const noteHtml =
        note !== null ? (
          <Linkify properties={{ target: '_blank' }} className="extraInfo">
            {renderHTML(note)}
          </Linkify>
        ) : null;

      contentAsNode = (
        <div className="col-xs-12 col-sm-9">
          <Linkify properties={{ target: '_blank' }}>
            {renderHTML(actualContent)}
          </Linkify>
          {noteHtml}
        </div>
      );
    }

    if (contentAsNode === null) {
      return null;
    }

    return (
      <div className={`row overview ${className}`}>
        <div className="col-xs-12 col-sm-3">
          <label>{renderHTML(label)}</label>
        </div>
        {contentAsNode}
      </div>
    );
  }

  return null;
};

DetailField.propTypes = {
  label: PropTypes.string.isRequired,
  content: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.number,
  ]),
  extra: PropTypes.string,
  className: PropTypes.string,
};

export default DetailField;



// WEBPACK FOOTER //
// ./src/components/DetailField/DetailField.js